import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { IBankMeta } from "../../api/interface"

export type IRecipient = {
  id?: string
  name?: string
  phone: string
}

type IC2CSlice = {
  selectedBank: IBankMeta | null
  defaultBank: IBankMeta | null
  recipient: IRecipient | null
  bankVariants: IBankMeta[]
  paymentPurpose: string
  amount: {
    value: string
  }
}

const initialState: IC2CSlice = {
  selectedBank: null,
  defaultBank: null,
  bankVariants: [],
  recipient: null,
  paymentPurpose: "",
  amount: {
    value: "",
  },
}

const c2cSclice = createSlice({
  name: "c2cPush",
  initialState,
  reducers: {
    setSelectedBank: (state, action: PayloadAction<IBankMeta | null>) => {
      if (
        action.payload &&
        state.selectedBank?.bankId !== action.payload.bankId
      ) {
        state.selectedBank = action.payload
      }
    },
    setBankVariant: (state, action: PayloadAction<IBankMeta>) => {
      const selectedBank = action.payload

      state.selectedBank = selectedBank
      state.bankVariants = [
        ...state.bankVariants.filter(
          (bank) => bank.bankId !== selectedBank.bankId,
        ),
        selectedBank,
      ]
    },
    setAmount: (state, action: PayloadAction<string>) => {
      state.amount.value = action.payload
    },
    setDefaultBank: (state, action: PayloadAction<IBankMeta>) => {
      state.defaultBank = action.payload
    },
    setRecipient: (state, action: PayloadAction<IRecipient>) => {
      state.recipient = action.payload
    },
    setPaymentPurpose: (state, action: PayloadAction<string>) => {
      state.paymentPurpose = action.payload
    },
    resetSlice: () => initialState,
    resetSliceWithArgs: (
      state,
      action: PayloadAction<Partial<IC2CSlice>>,
    ) => ({
      ...initialState,
      ...action.payload,
    }),
  },
})

export const {
  setSelectedBank,
  setBankVariant,
  setAmount,
  setRecipient,
  setPaymentPurpose,
  resetSlice,
  resetSliceWithArgs,
  setDefaultBank,
} = c2cSclice.actions

export default c2cSclice.reducer
